export default __webpack_public_path__ + "static/media/84534C48-8C2F-428B-8563-84BACAA5EA4F.c3466885.jpg";